import { BedSingle, Building, Building2, House, type LucideIcon } from 'lucide-react';
import type { MarkerIconType } from '@/src/components/features/search/Map/types';

/**
 * Derives the canonical icon type from a listing's propertyType and listingType.
 * Single source of truth used by both the map marker system and the listing card.
 *
 * Handles v2 types (duplex, apartment) and v3 SearchPropertyType values
 * (divided, large, garden, medium, unknown, land).
 */
export function getListingIconType(
  propertyType: string | undefined | null,
  listingType: string | undefined | null,
): MarkerIconType {
  if (listingType === 'room') return 'room';
  switch (propertyType) {
    case 'house':
      return 'house';
    case 'townhouse':
    case 'condo':
      return 'condo';
    case 'duplex': // v2
    case 'divided': // v3 equivalent
      return 'house';
    // 'large', 'garden', 'medium', 'apartment', 'unknown', 'land' → building
    default:
      return 'building';
  }
}

/**
 * The property-type icon shown wherever a listing's identity is conveyed by
 * icon rather than text — `ListingCard`'s identity line and the HDP's
 * address line both key off this map via `getListingIconType`.
 */
export const ICON_FOR_LISTING_TYPE: Record<MarkerIconType, LucideIcon> = {
  building: Building2,
  condo: Building,
  house: House,
  room: BedSingle,
};
